/** Called when API returns 401 — wired from AuthProvider to clear local session. */

let unauthorizedHandler = null;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = typeof handler === 'function' ? handler : null;
}

export function notifyUnauthorized() {
  unauthorizedHandler?.();
}
